import React, { FC, useMemo, useState } from "react";
import classes from "./CurrentServicesStatusPage.module.scss";
import CurrentServicesStatusTableQueue from "../../../components/Admin/Tables/AnalyticsAndReports/CurrentServicesStatusTable/CurrentServicesStatusTableQueue";
import CurrentServicesStatusTableEmployers from "../../../components/Admin/Tables/AnalyticsAndReports/CurrentServicesStatusTable/CurrentServicesStatusTableEmployers";
import HeaderAnalyticsTables from "../../../components/Admin/HeaderAnalyticsAndReports/HeaderAnalyticsTables";
import { useGetCurrentServicesEmployees } from "../../../hooks/Admin/AnalyticsAndReportsTables/CurrentServicesStatusTable/useGetCurrentServicesEmployees";
import { useGetCurrentServicesQueue } from "../../../hooks/Admin/AnalyticsAndReportsTables/CurrentServicesStatusTable/useGetCurrentServicesQueue";
import BranchQueueFilter from "../../../components/Admin/BranchQueueFilter/BranchQueueFilter";
import { useAdminQueueIdsFilter } from "../../../hooks/Admin/useAdminQueueIdsFilter";

const tabsList = ["Очередь", "Рабочие места"];
const isActiveButtonCSV = false;

const OPERATOR_STATUSES = [
  "Свободен",
  "Обслуживает",
  "Ожидает пациента",
  "Занят",
  "Перерыв",
  "Отсутствует",
];

const CurrentServicesStatusPage: FC = () => {
  const [activeTab, setActiveTab] = useState(tabsList[0]);
  const [filterBranchIds, setFilterBranchIds] = useState<number[]>([]);
  const [filterQueueIds, setFilterQueueIds] = useState<number[]>([]);
  const selectedBranchQueueId = filterQueueIds.length
    ? filterQueueIds[0]
    : null;
  const isQueueSelected = selectedBranchQueueId != null;
  const { queueIdsFilter } = useAdminQueueIdsFilter();

  const {
    currentServicesEmployeesResp: EmployeesTableData,
    isLoadingCurrentServicesEmployees,
  } = useGetCurrentServicesEmployees(selectedBranchQueueId);
  const {
    currentServicesQueueResp: QueueTableData,
    isLoadingCurrentServicesQueue,
  } = useGetCurrentServicesQueue(selectedBranchQueueId);

  const operatorStatusCounts = useMemo(() => {
    const counts = new Map<string, number>(
      OPERATOR_STATUSES.map((status) => [status, 0]),
    );
    (EmployeesTableData ?? []).forEach((row) => {
      const status = row.status || "Свободен";
      counts.set(status, (counts.get(status) ?? 0) + 1);
    });
    return OPERATOR_STATUSES.map((status) => ({
      status,
      count: counts.get(status) ?? 0,
    }));
  }, [EmployeesTableData]);

  return (
    <div className={classes.container}>
      <HeaderAnalyticsTables
        tabs={tabsList}
        isActiveButtonCSV={isActiveButtonCSV}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        name="Текущее состояние обслуживания посетителей"
        filterContent={
          <BranchQueueFilter
            selectedBranchIds={filterBranchIds}
            selectedQueueIds={filterQueueIds}
            onBranchChange={setFilterBranchIds}
            onQueueChange={setFilterQueueIds}
            singleQueue
            queueIdsFilter={queueIdsFilter}
          />
        }
      />

      {!isQueueSelected ? (
        <div className={classes.emptyState}>
          Выберите очередь в фильтре, чтобы отобразить данные
        </div>
      ) : (
        <div className={classes.reportBody}>
          <div className={classes.statusSummary}>
            {operatorStatusCounts.map((item) => (
              <div key={item.status} className={classes.statusCard}>
                <span className={classes.statusCount}>
                  {isLoadingCurrentServicesEmployees ? "—" : item.count}
                </span>
                <span className={classes.statusLabel}>{item.status}</span>
              </div>
            ))}
          </div>
          {"Очередь" === activeTab && (
            <CurrentServicesStatusTableQueue
              QueueTableData={QueueTableData}
              isLoadingData={isLoadingCurrentServicesQueue}
            />
          )}
          {"Рабочие места" === activeTab && (
            <CurrentServicesStatusTableEmployers
              EmployeesTableData={EmployeesTableData}
              isLoadingData={isLoadingCurrentServicesEmployees}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default CurrentServicesStatusPage;
